import { SITE_URL, absoluteUrl } from "./img";

// Lightweight head-tag manager for per-article SEO in a single-page app.
const DEFAULTS = {};

function metaEl(selector, create) {
  let el = document.head.querySelector(selector);
  if (!el && create) {
    el = document.createElement(create.tag);
    Object.entries(create.attrs).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  return el;
}

const TAGS = {
  description: ['meta[name="description"]', { tag: "meta", attrs: { name: "description" } }, "content"],
  canonical: ['link[rel="canonical"]', { tag: "link", attrs: { rel: "canonical" } }, "href"],
  ogType: ['meta[property="og:type"]', { tag: "meta", attrs: { property: "og:type" } }, "content"],
  ogUrl: ['meta[property="og:url"]', { tag: "meta", attrs: { property: "og:url" } }, "content"],
  ogTitle: ['meta[property="og:title"]', { tag: "meta", attrs: { property: "og:title" } }, "content"],
  ogDescription: ['meta[property="og:description"]', { tag: "meta", attrs: { property: "og:description" } }, "content"],
  ogImage: ['meta[property="og:image"]', { tag: "meta", attrs: { property: "og:image" } }, "content"],
  ogImageAlt: ['meta[property="og:image:alt"]', { tag: "meta", attrs: { property: "og:image:alt" } }, "content"],
  twTitle: ['meta[name="twitter:title"]', { tag: "meta", attrs: { name: "twitter:title" } }, "content"],
  twDescription: ['meta[name="twitter:description"]', { tag: "meta", attrs: { name: "twitter:description" } }, "content"],
  twImage: ['meta[name="twitter:image"]', { tag: "meta", attrs: { name: "twitter:image" } }, "content"],
};

function captureDefaults() {
  if (DEFAULTS.__done) return;
  DEFAULTS.title = document.title;
  Object.entries(TAGS).forEach(([key, [sel, , attr]]) => {
    const el = metaEl(sel);
    DEFAULTS[key] = el ? el.getAttribute(attr) : null;
  });
  DEFAULTS.__done = true;
}

function setTag(key, value) {
  const [sel, create, attr] = TAGS[key];
  if (value == null) return;
  const el = metaEl(sel, create);
  el.setAttribute(attr, value);
}

export function postUrl(post) {
  return `${SITE_URL}/blog/${post.id}`;
}

export function applyPostSeo(post) {
  captureDefaults();
  const title = `${post.title} | Dr. Maggie Cadet, MD`;
  const url = postUrl(post);
  const img = absoluteUrl(post.image);
  document.title = title;
  setTag("description", post.excerpt);
  setTag("canonical", url);
  setTag("ogType", "article");
  setTag("ogUrl", url);
  setTag("ogTitle", title);
  setTag("ogDescription", post.excerpt);
  setTag("ogImage", img);
  setTag("ogImageAlt", post.alt);
  setTag("twTitle", title);
  setTag("twDescription", post.excerpt);
  setTag("twImage", img);
}

export function resetSeo() {
  if (!DEFAULTS.__done) return;
  document.title = DEFAULTS.title;
  Object.keys(TAGS).forEach((key) => {
    if (DEFAULTS[key] != null) setTag(key, DEFAULTS[key]);
  });
}

export function slugFromPath(pathname) {
  const m = /^\/blog\/([a-z0-9-]+)\/?$/i.exec(pathname || "");
  return m ? m[1].toLowerCase() : null;
}
